import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './registerServiceWorker'
Vue.config.productionTip = false

window.debuglog = (message) => console.log(`OTTO: ${message}`);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
